<mat-card id="cadastro">
    <mat-card-header>
      <div fxLayout="row" fxLayoutAlign="center center">
        <div fxFlex="300px">
          <h3>INCLUSÃO DO EDITAL</h3>
        </div>
      </div>
    </mat-card-header>

    <mat-card-content>
      <p></p>

      <form [formGroup]="form"   class="formulario">

        <div fxLayout.align="center center" fxLayout.xs="column" fxLayoutGap="20px">

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="area  campo_flex tamanho_33">
               <mat-label> Area :</mat-label>
               <input matInput formControlName="area" >
            </mat-form-field>

            <mat-form-field class="processo  campo_flex tamanho_33">
              <mat-label> Processo :</mat-label>
              <input matInput formControlName="processo"  >
           </mat-form-field>            

           <mat-form-field class="inscricao  campo_flex tamanho_33">
              <mat-label> Inscricao :</mat-label>
              <input matInput formControlName="inscricao" readonly >
           </mat-form-field>    

          </div>

          <div class="form_linha" fxLayout.xs="column" class="titupload">
            <h4>
              DADOS DO CANDIDATO
            </h4>
          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="nome  campo_flex tamanho_50">
               <mat-label> Nome :</mat-label>
               <input matInput formControlName="nome" >
            </mat-form-field>

            <mat-form-field class="cpf  campo_flex tamanho_25">
              <mat-label> Cpf :</mat-label>
              <input matInput formControlName="cpf"  >
           </mat-form-field>            

           <mat-form-field class="nasc  campo_flex tamanho_25">
              <mat-label> Dt Nasc.:</mat-label>
              <input matInput formControlName="nasc" mask="00/00/0000" >
           </mat-form-field>    

          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="ident  campo_flex tamanho_33">
              <mat-label> Identidade :</mat-label>
              <input matInput formControlName="ident" >
            </mat-form-field>

            <mat-form-field class="orgid  campo_flex tamanho_33">
              <mat-label> Org.Exp.:</mat-label>
              <input matInput formControlName="orgid"  >
            </mat-form-field>            

            <mat-form-field class="dtid  campo_flex tamanho_33">
              <mat-label> Dt Exp.:</mat-label>
              <input matInput formControlName="dtid" mask="00/00/0000" >
            </mat-form-field>    
 
          </div>          

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="endereco  campo_flex tamanho_50">
              <mat-label> Endereco :</mat-label>
              <input matInput formControlName="endereco" >
            </mat-form-field>

            <mat-form-field class="num  campo_flex tamanho_25">
              <mat-label> Numero :</mat-label>
              <input matInput formControlName="num"  >
            </mat-form-field>            

            <mat-form-field class="complemento  campo_flex tamanho_25">
              <mat-label> Complemento:</mat-label>
              <input matInput formControlName="complemento"  >
            </mat-form-field>    

          </div>
-
          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="bairro  campo_flex tamanho_50">
              <mat-label> Bairro :</mat-label>
              <input matInput formControlName="bairro" >
            </mat-form-field>

            <mat-form-field class="cidade  campo_flex tamanho_25">
              <mat-label> Cidade :</mat-label>
              <input matInput formControlName="cidade"  >
            </mat-form-field>            

            <mat-form-field class="uf  campo_flex tamanho_25">
              <mat-label> UF:</mat-label>
              <input matInput formControlName="uf"  >
            </mat-form-field>    

          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="cep  campo_flex tamanho_25">
              <mat-label> CEP :</mat-label>
              <input matInput formControlName="cep" mask="00.000-000" >
            </mat-form-field>

            <mat-form-field class="cel  campo_flex tamanho_25">
              <mat-label> Celular :</mat-label>
              <input matInput formControlName="cel" mask="(00) 0000-00000" >
            </mat-form-field>            

            <mat-form-field class="email campo_flex tamanho_50">
              <mat-label> E-mail:</mat-label>
              <input matInput formControlName="email"  >
            </mat-form-field>    

          </div>



          <div class="form_linha" fxLayout.xs="column" class="titupload">
            <h4>
              DADOS DO ORIENTADOR-----------------------------------&nbsp;&nbsp;&nbsp;DADOS DO COORIENTADOR----------------------------
            </h4>
          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="orientador  campo_flex tamanho_25">
              <mat-label> Nome  :</mat-label>
              <input matInput formControlName="orientador" >
            </mat-form-field>

            <mat-form-field class="cpfori  campo_flex tamanho_25">
              <mat-label> Cpf :</mat-label>
              <input matInput formControlName="cpfori"  >
            </mat-form-field>            

            <mat-form-field class="coorientador campo_flex tamanho_25">
              <mat-label> Nome:</mat-label>
              <input matInput formControlName="coorientador"  >
            </mat-form-field>    

            <mat-form-field class="cpfcoori campo_flex tamanho_25">
              <mat-label> Cpf:</mat-label>
              <input matInput formControlName="cpfcoori"  >
            </mat-form-field>  
          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="emailori  campo_flex tamanho_25">
              <mat-label> E-mail  :</mat-label>
              <input matInput formControlName="emailori" >
            </mat-form-field>

            <mat-form-field class="celori  campo_flex tamanho_25">
              <mat-label> Cel :</mat-label>
              <input matInput formControlName="celori"  >
            </mat-form-field>            

            <mat-form-field class="emailcoori campo_flex tamanho_25">
              <mat-label> Email:</mat-label>
              <input matInput formControlName="emailcoori"  >
            </mat-form-field>    

            <mat-form-field class="celcoori campo_flex tamanho_25">
              <mat-label> Cel:</mat-label>
              <input matInput formControlName="celcoori"  >
            </mat-form-field>  
          </div>


          <div class="form_linha" fxLayout.xs="column" class="titupload">
            <h4>
              DADOS DO PROJETO DE PESQUISA
            </h4>
          </div>


          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="titulo  campo_flex tamanho_100">
              <mat-label> Titulo  :</mat-label>
              <input matInput formControlName="titulo" >
            </mat-form-field>

          </div>

          <div class="form_linha" fxLayout.xs="column">

            <mat-form-field class="aprov  campo_flex tamanho_25">
              <mat-label>Aprov. Cons. Ética :</mat-label>
              <input matInput formControlName="aprov" >
            </mat-form-field>

            <mat-form-field class="protocolo campo_flex tamanho_25">
              <mat-label> Protocolo :</mat-label>
              <input matInput formControlName="protocolo"  >
            </mat-form-field>            

            <mat-form-field class="humana campo_flex tamanho_25">
              <mat-label>Usa Amostras Humanas:</mat-label>
              <input matInput formControlName="humana"  >
            </mat-form-field>    

            <mat-form-field class="ogm campo_flex tamanho_25">
              <mat-label>Usa O.G.M. :</mat-label>
              <input matInput formControlName="ogm"  >
            </mat-form-field>  
          </div>
   

          <div class="form_linha" fxLayout.xs="column">
            <hr>
          </div>




          <!--
          <section class="campo_flex tamanho_100 flex_wrap">
            <div class="campo_flex tamanho_25"><font color="#FF0000" size="4" >- E D I T A L </font></div>

          <div class="campo_flex tamanho_50" >

            <a href="{{caminhoArquivosUpload}}{{m_filename1}}" target="_blank">{{m_filename1}}</a>
            <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUp('1',caminhoArquivosUpload,m_filename1)"><mat-icon>upload</mat-icon></button>

          </div>


          </section>
         -->
        

          


          <div fxLayoutAlign="center center" class="form_linha botoes">

            <button type="button" mat-raised-button name="retorna" color="warn" (click)="retorna()" >
              Retorna
            </button>

            <button type="button" mat-raised-button name="solicita" color="primary" (click)="retorna()" [disabled]= this.ativa >
              Confirmar Gravação
            </button>

          </div>



        </div>

      </form>

    </mat-card-content>

  </mat-card>

